/**
 * Welloura Product Stories — Embla-like carousel + dots for <768px (live cA / _o).
 */
(function () {
  const MQ = '(max-width: 767px)';

  function initStories(root) {
    const viewport = root.querySelector('[data-wl-stories-viewport]');
    const track = root.querySelector('[data-wl-stories-track]');
    const slides = Array.from(root.querySelectorAll('[data-wl-stories-slide]'));
    const dots = Array.from(root.querySelectorAll('[data-wl-stories-dot]'));
    if (!viewport || !track || !slides.length) return;

    const accent =
      getComputedStyle(root).getPropertyValue('--wl-pd-accent').trim() ||
      getComputedStyle(document.documentElement).getPropertyValue('--optix').trim();
    let active = 0;
    let drag = null;
    let trackX = 0;

    function isMobile() {
      return window.matchMedia(MQ).matches;
    }

    function maxIndex() {
      return slides.length - 1;
    }

    function slideOffset(index) {
      return slides[index] ? slides[index].offsetLeft : 0;
    }

    function setX(x, animate) {
      trackX = x;
      track.style.transition = animate
        ? 'transform 0.35s cubic-bezier(0.4, 0, 0.2, 1)'
        : 'none';
      track.style.transform = 'translate3d(' + -x + 'px,0,0)';
    }

    function syncDots() {
      dots.forEach((dot, i) => {
        const on = i === active;
        dot.classList.toggle('is-active', on);
        dot.setAttribute('aria-current', on ? 'true' : 'false');
        /* live: active = primary, inactive = primary + "40" hex alpha */
        dot.style.background = on ? accent : accent + '40';
      });
    }

    function goTo(index, animate) {
      if (!isMobile()) {
        setX(0, false);
        return;
      }
      const i = Math.max(0, Math.min(index, maxIndex()));
      active = i;
      setX(slideOffset(i), animate !== false);
      syncDots();
    }

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        goTo(parseInt(dot.dataset.index, 10) || 0, true);
      });
    });

    function onPointerDown(e) {
      if (!isMobile()) return;
      drag = {
        id: e.pointerId,
        startX: e.clientX,
        origin: trackX,
        moved: false,
      };
      viewport.classList.add('is-dragging');
      track.style.transition = 'none';
      try {
        viewport.setPointerCapture(e.pointerId);
      } catch (err) {
        /* ignore */
      }
    }

    function onPointerMove(e) {
      if (!drag || e.pointerId !== drag.id) return;
      const delta = e.clientX - drag.startX;
      if (Math.abs(delta) > 3) drag.moved = true;
      const maxX = slideOffset(maxIndex());
      let next = drag.origin - delta;
      if (next < 0) next *= 0.35;
      if (next > maxX) next = maxX + (next - maxX) * 0.35;
      setX(next, false);
    }

    function onPointerUp(e) {
      if (!drag || e.pointerId !== drag.id) return;
      const delta = e.clientX - drag.startX;
      const moved = drag.moved;
      drag = null;
      viewport.classList.remove('is-dragging');
      if (moved && Math.abs(delta) > 40) {
        goTo(active + (delta < 0 ? 1 : -1), true);
      } else {
        goTo(active, true);
      }
    }

    viewport.addEventListener('pointerdown', onPointerDown);
    viewport.addEventListener('pointermove', onPointerMove);
    viewport.addEventListener('pointerup', onPointerUp);
    viewport.addEventListener('pointercancel', onPointerUp);

    window.addEventListener('resize', () => {
      goTo(isMobile() ? active : 0, false);
    });

    goTo(0, false);
  }

  function boot() {
    document.querySelectorAll('[data-wl-stories]').forEach(initStories);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
